module.exports = __webpack_public_path__ + "img/07.6b7c1c43.jpg";